import type { QuestionRendererProps } from '../types';

export const ReadOnlyTextQuestion = ({ question }: QuestionRendererProps<null>) => {
  if (question.type !== 'read_only_text') {
    return null;
  }

  return null;
};
